"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProjectableDataObjectConverter_1 = require("./ProjectableDataObjectConverter");

var ProjectableReaderConverter_1 = require("./ProjectableReaderConverter");
/**
 */


var ProjectableReaderObjectConverter =
/*#__PURE__*/
function (_ProjectableDataObjec) {
  _inherits(ProjectableReaderObjectConverter, _ProjectableDataObjec);

  function ProjectableReaderObjectConverter() {
    _classCallCheck(this, ProjectableReaderObjectConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProjectableReaderObjectConverter).apply(this, arguments));
  }

  _createClass(ProjectableReaderObjectConverter, [{
    key: "getProjection",
    value: function getProjection() {
      if (!this.projection) {
        this.projection = new ProjectableReaderConverter_1.ProjectableReaderConverter(this.readers);
      }

      return this.projection;
    }
  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var material = this.getProjection().toObject(source, conversions);
      return this.materializer(material);
    }
  }]);

  return ProjectableReaderObjectConverter;
}(ProjectableDataObjectConverter_1.ProjectableDataObjectConverter);

exports.ProjectableReaderObjectConverter = ProjectableReaderObjectConverter;